//App
import { SettingProps, SettingContextData } from "../../../../types/setting";

import useForm from "../../../hooks/useForm";
import { SettingContext } from "../SettingsContainer";

const useSetting = (props: SettingProps) => {
  return useForm<SettingContextData, SettingProps>(SettingContext, props);
};

export default useSetting;
